import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21 14a3 3 0 0 1-3 3h-3.759l1.904-1.705a.75.75 0 0 0-1-1.117L11.992 17h-2.72a1 1 0 1 0 0 2H18a5 5 0 0 0 5-5V9.636A4.636 4.636 0 0 0 18.364 5a1 1 0 0 0 0 2c1.25 0 2.298.871 2.568 2.04l-2.972 2.494a.75.75 0 0 0 .965 1.15L21 10.941zM5.636 19a1 1 0 1 0 0-2 2.63 2.63 0 0 1-1.858-.766l7.21-6.164a.75.75 0 0 0-.975-1.14L3.05 14.882A2.7 2.7 0 0 1 3 14.364V10a3 3 0 0 1 3-3h8.727a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v4.364A4.636 4.636 0 0 0 5.636 19",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_sun_rooftop-BH7lbqme.js.map
